import type { AddressModel, PropertyOnboardingModel } from 'src/api/models';

type GetHomeownerPropertyByAddressParams = {
  address: AddressModel;
  homeownerProperties: PropertyOnboardingModel[];
};

export function getHomeownerPropertyByAddress({
  address,
  homeownerProperties,
}: GetHomeownerPropertyByAddressParams): PropertyOnboardingModel | undefined {
  return homeownerProperties?.find(({ address: homeownerPropertyAddress }) => {
    const { city, state, streetAddress, zipcode } =
      homeownerPropertyAddress || {};

    const {
      city: currentAddressCity,
      state: currentAddressState,
      streetAddress: currentAddressStreetAddress,
      zipcode: currentAddressZipCode,
    } = address || {};

    return (
      city === currentAddressCity &&
      state === currentAddressState &&
      streetAddress === currentAddressStreetAddress &&
      zipcode === currentAddressZipCode
    );
  });
}
